import { observer } from "mobx-react-lite";
import React from "react";
import AppState, { POPUPS, SCREENS } from "../../js/AppState";

import ScaleManager from 'react-sdk/ScaleManager';
import ScreenHome from "../ScreenHome/ScreenHome";
import ScreenLoading from "../ScreenLoading/ScreenLoading";

import PopupsManager from "react-sdk/PopupsManager";
import PopupMentionLegales from "../popups/PopupMentionLegales/PopupMentionLegales";
import PopupOrientation from "../popups/PopupOrientation/PopupOrientation";
import PopupReglesTirage from "../popups/PopupReglesTirage/PopupReglesTirage";
import ScreenEndGame from "../ScreenEndGame/ScreenEndGame";
import ScreenGame from "../ScreenGame/ScreenGame";
import Notifs from "../shared/Notifs/Notifs";
import './App.css';




const App = () => {

  return (
    <>
      <div className="App"  style={ScaleManager.style}>
        {AppState.screen === SCREENS.LOADING && <ScreenLoading />}
        {AppState.screen === SCREENS.HOME && <ScreenHome />}
        {AppState.screen === SCREENS.END_GAME && <ScreenEndGame />}
        {AppState.screen === SCREENS.GAME && <ScreenGame />}

        <Notifs />

        {PopupsManager.isOpened(POPUPS.MENTIONS_LEGALES) && <PopupMentionLegales />}
        {PopupsManager.isOpened(POPUPS.REGLES_TIRAGE) && <PopupReglesTirage />}
        {PopupsManager.isOpened(POPUPS.ORIENTATION) && <PopupOrientation />}

        {/* <div className="version">{import.meta.env.VITE_APP_VERSION}</div> */}
        {/* {AppState.debugMode && <div className="debug">Debug mode: {AppState.debugMode}</div>} */}
      </div>

    </>
  )
}

export default observer(App);
